import { render, staticRenderFns } from "./AlternateScreenings.vue?vue&type=template&id=4c46a32f&scoped=true&"
import script from "./AlternateScreenings.vue?vue&type=script&lang=js&"
export * from "./AlternateScreenings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c46a32f",
  null
  
)

export default component.exports